/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomerDtoFromJSON, CustomerDtoToJSON, ReservationDetailDtoFromJSON, ReservationDetailDtoToJSON, } from './';
export function CustomerWithReservationDtoFromJSON(json) {
    return CustomerWithReservationDtoFromJSONTyped(json, false);
}
export function CustomerWithReservationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reservation': !exists(json, 'reservation') ? undefined : ReservationDetailDtoFromJSON(json['reservation']),
        'customer': !exists(json, 'customer') ? undefined : CustomerDtoFromJSON(json['customer']),
    };
}
export function CustomerWithReservationDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reservation': ReservationDetailDtoToJSON(value.reservation),
        'customer': CustomerDtoToJSON(value.customer),
    };
}
